const BADGE_CONFIG = {
  0:  { bg: 'bg-red-100',    text: 'text-red-800',    border: 'border-red-300',    label: 'À importer' },
  1:  { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-300', label: 'Vérification en cours' },
  2:  { bg: '',              text: '',                 border: '',                  label: '' },
  3:  { bg: 'bg-red-100',    text: 'text-red-800',    border: 'border-red-300',    label: 'Refusé' },
  4:  { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-300', label: 'À vérifier' },
  5:  { bg: 'bg-green-100',  text: 'text-green-800',  border: 'border-green-300',  label: 'Validé' },
  6:  { bg: 'bg-green-100',  text: 'text-green-800',  border: 'border-green-300',  label: 'Lu' },
  7:  { bg: 'bg-red-100',    text: 'text-red-800',    border: 'border-red-300',    label: 'Non Lu' },
  8:  { bg: 'bg-red-100',    text: 'text-red-800',    border: 'border-red-300',    label: 'À supprimer' },
  9:  { bg: 'bg-gray-100',   text: 'text-gray-800',   border: 'border-gray-300',   label: 'Non signé' },
  10: { bg: 'bg-green-100',  text: 'text-green-800',  border: 'border-green-300',  label: 'Signé' },
  11: { bg: 'bg-red-100',    text: 'text-red-800',    border: 'border-red-300',    label: 'Urgent' },
  12: { bg: 'bg-green-100',  text: 'text-green-800',  border: 'border-green-300',  label: 'Importé' },
  13: { bg: 'bg-gray-100',   text: 'text-gray-800',   border: 'border-gray-300',   label: 'Non importé' },
  14: { bg: 'bg-green-100',  text: 'text-green-800',  border: 'border-green-300',  label: 'Payé' },
  15: { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-300', label: 'Non payé' },
  16: { bg: 'bg-blue-100',   text: 'text-blue-800',   border: 'border-blue-300',   label: 'Partiellement payé' },
  17: { bg: 'bg-red-100',    text: 'text-red-800',    border: 'border-red-300',    label: 'En retard' },
  18: { bg: 'bg-gray-100',   text: 'text-gray-800',   border: 'border-gray-300',   label: 'Annulé' },
  19: { bg: 'bg-gray-100',   text: 'text-gray-800',   border: 'border-gray-300',   label: 'Brouillon' },
  20: { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-300', label: 'En attente' },
  21: { bg: 'bg-orange-100', text: 'text-orange-800', border: 'border-orange-300', label: 'À importer sur PennyLane' },
  22: { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-300', label: 'Suspendue' },
  23: { bg: 'bg-gray-100',   text: 'text-gray-900',   border: 'border-gray-300',   label: 'Annulée' },
  24: { bg: 'bg-gray-100',   text: 'text-gray-900',   border: 'border-gray-300',   label: 'Interrompue' },
  25: { bg: 'bg-red-100',    text: 'text-red-800',    border: 'border-red-300',    label: 'Supprimée' },
  26: { bg: 'bg-green-100',  text: 'text-green-800',  border: 'border-green-300',  label: 'Validé par IA' },
};

const BadgeSquare = ({ type, bordered = false, customLabel, size = 'sm' }) => {
  const config = BADGE_CONFIG[type];
  if (!config) return null;

  const label = customLabel || config.label;
  if (!label) return null;

  const textSize =
    size === 'xs'
      ? 'text-xs px-1.5 py-0.5'
      : size === '12'
        ? 'text-[12px] leading-tight px-2 py-0.5'
        : 'text-sm px-2 py-0.5';

  return (
    <div className={`flex justify-center items-center rounded ${config.bg} ${bordered ? `border ${config.border}` : ''} max-w-full overflow-hidden`}>
      <div className={`${textSize} ${config.text} whitespace-nowrap truncate font-medium`}>{label}</div>
    </div>
  );
};

export default BadgeSquare;
